const getDefaultChoiceGroupStyles = (props) => {
    const { theme } = props;
    return {
        root: {},
        label: {
            color: theme.semanticColors.inputPlaceholderText,
        },
        flexContainer: {},
    };
};
export function getChoiceGroupStyles(props) {
    return getDefaultChoiceGroupStyles(props);
}
export function getM365ChoiceGroupStyles(props) {
    const choiceGroupStyles = getDefaultChoiceGroupStyles(props);
    return {
        ...choiceGroupStyles,
        subComponentStyles: {
            preTextIcon: {
                root: {
                    left: '32px',
                },
            },
        },
    };
}
//# sourceMappingURL=ChoiceGroup.styles.js.map